module.exports = __webpack_public_path__ + "img/big.7b9bf09c.jpg";